/* para V1.27: お気に入り(Swish / Wishlist King)の文言を英語に差し替える。
   Swish の画面の文字(見出し・ログイン案内・0 件の文・SHARE・カートに入れるボタンなど)は、アプリが自分の翻訳ファイル
   (cdn.appmate.io/themecode-templates/locale-ja.json)から読む。アプリは読み込みのとき、本文末尾の
   <script id="wkThemeCode">(Code Access のブロックが出す JSON)の localeJsonUrl が入っていれば、そのファイルを優先する。
   この defer スクリプトは本文末尾のアプリのモジュールより先に実行されるので、そこへ assets/para-swish-locale.json の URL を入れる。
   文言の直し方: assets/para-swish-locale.json を編集(キーはアプリの翻訳ファイルと同じ。足りないキーは入れない・消さない)。
   アプリ側(Swish > Settings > Code Editor > Translations)の保存で localeJsonUrl が最初から入っているときは、そちらを優先してここは何もしない(想定。staging で確認)。 */
(function () {
  'use strict';
  try {
    var script = document.currentScript || document.querySelector('script[data-locale-url]');
    var url = script && script.getAttribute('data-locale-url');
    var el = document.getElementById('wkThemeCode');
    if (!url || !el) return;
    var data = JSON.parse(el.textContent);
    if (data && !data.localeJsonUrl) {
      data.localeJsonUrl = url;
      el.textContent = JSON.stringify(data);
    }
  } catch (e) { /* アプリ側の形式が変わったときは、アプリ既定の翻訳のまま */ }
})();
